var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blackout",class:{blocked: _vm.blocked, show: _vm.show}},[_c('div',{staticClass:"content vertical-align"},[_c('Spinner'),_c('div',{staticClass:"message",class:{show : _vm.processingMsg}},[_vm._v(_vm._s(_vm.processingMsg))]),_c('div',{staticClass:"message",class:{show : _vm.slowLoadMsg}},[_vm._v(_vm._s(_vm.slowLoadMsg))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }